import { render, staticRenderFns } from "./LotteryWinners.vue?vue&type=template&id=09255c75&scoped=true"
import script from "./LotteryWinners.vue?vue&type=script&lang=js"
export * from "./LotteryWinners.vue?vue&type=script&lang=js"
import style0 from "./LotteryWinners.vue?vue&type=style&index=0&id=09255c75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09255c75",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2DesktopLotteryWinnerCount: require('/app/components/Theme2/Desktop/LotteryWinnerCount.vue').default})
